export const tool = {
  name: 'soda',
  description:
    'A tool that modifies the 3D model’s object, such as shape, size, or structure, based on a prompt.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      prompt: {
        type: 'string',
        description: 'Instructions to modify the 3D model’s object.',
      },
      message: {
        type: 'string',
        default: 'Modify model structure',
      },
    },
    required: ['prompt', 'message'],
  },
};
